@let displayPricePer = usePricePerPrimary();
@let displayContainerPricePer = usePricePerSecondary();

@if (!priceLoading() && hasError()) {
  <ideal-error [error]="error()" mode="button"></ideal-error>
} @else {
  <div content withLoadingSkeleton [isLoading]="priceLoading()">
    <ideal-item-price-view
      price
      [usePricePer]="displayPricePer"
      [multiplyBy]="multiplyBy()"
      [layout]="layout()"
      [align]="align()"
      [disableCallForPrice]="disableCallForPrice()"
      [disableRegularPrice]="disableRegularPrice()"
      [disableUnits]="disableUnits()"
      [disableSalesNotice]="disableSalesNotice()"
      [disableFees]="disableFees()"
      [disableSales]="disableSales()"
      [sizing]="sizing()"
      [pricing]="pricing()"
    ></ideal-item-price-view>
    @if (displayContainerPricePer) {
      <div class="divider"><span>or</span></div>
      <ideal-item-price-view
        container-price
        [usePricePer]="displayContainerPricePer"
        [multiplyBy]="multiplyBy()"
        [layout]="layout()"
        [align]="align()"
        [disableCallForPrice]="disableCallForPrice()"
        [disableRegularPrice]="disableRegularPrice()"
        [disableUnits]="disableUnits()"
        [disableSalesNotice]="true"
        [disableFees]="true"
        [disableSales]="disableSales()"
        [sizing]="sizing()"
        [pricing]="pricing()"
        class="container-price"
      ></ideal-item-price-view>
    }
  </div>
}
